import ScrollMagic from "scrollmagic";

const Hero = () => {
	const heroHome = document.querySelector(".home .hero--primary");

	if (heroHome) {
		const videoHero = heroHome.getElementsByTagName("video")[0];
		const headerDesktop = document.getElementById("header-desktop");
		const headerMobile = document.getElementById("header-mobile");

		if (videoHero) {
			headerDesktop.classList.add("header--tween-bg");
			headerMobile.classList.add("header--tween-bg");
			let controller;

			// scrollMagic

			/* eslint-disable */

			var viewer = heroHome,
				frame_count = 5,
				offset_value = 140;

			// init controller
			controller = new ScrollMagic.Controller({
				globalSceneOptions: {
					triggerHook: 0,
					reverse: true,
				},
			});

			// build scene
			const scene = new ScrollMagic.Scene({
				triggerElement: ".hero--primary",
				duration: frame_count * offset_value,
				triggerHook: "onLeave",
				offset: 0,
				reverse: true,
			}).addTo(controller);

			// build step frame scene
			for (var i = 1, l = frame_count; i <= l; i++) {
				new ScrollMagic.Scene({
					triggerElement: ".hero--primary",
					offset: i * offset_value,
				})
					.setClassToggle(".header--tween-bg", "frame" + i)
					.addTo(controller);
			}

			/* eslint-enable */
		} else {
			headerDesktop.classList.remove("header--tween-bg");
			headerMobile.classList.remove("header--tween-bg");
		}
	}
};

export default Hero;
